export const opacityDisabled = (flag?: boolean) => {
    return  flag ? 0.15 : 1
    
    
}

export const pointerEventsDisabled = (flag?:boolean) => {
    return  flag ? 'none' : 'initial'
    
}